import { PartialBrief } from '../../../../Types/Brief'
import pushTagEvent from '../../../../Utilities/GoogleTagManager/pushTagEvent'
import { removeStoredBrief, setStoredBrief } from '../../../../Utilities/Storage/brief'

export interface BriefDispatch {
  updateAttributes?: PartialBrief
  overwrite?: PartialBrief // replaces the brief state - intended as a reset
}

// The 'User Segmentation' Google Tag Manager event represents the moment where the app decides
// whether the user is a business or a leadfeed user.
//
interface TriggerSegmentationEventOnUserChangeArgs {
  existingBrief?: PartialBrief
  updatedBrief: PartialBrief
}
const triggerSegmentationEventOnUserChange = ({
  existingBrief,
  updatedBrief,
}: TriggerSegmentationEventOnUserChangeArgs): void => {
  if (updatedBrief.guest?.isBusinessUser === undefined) return
  if (existingBrief?.guest?.isBusinessUser === updatedBrief.guest?.isBusinessUser) return

  pushTagEvent(updatedBrief, 'userSegmentation')
}

const briefReducer = (briefState: PartialBrief, dispatchArgs: BriefDispatch): PartialBrief => {
  const { updateAttributes, overwrite } = dispatchArgs
  if (overwrite) {
    removeStoredBrief() // only subsequent state updates will be locally stored
    return overwrite
  }

  if (!updateAttributes) {
    throw new Error('Brief reducer must be called with attributes to update or a reset param')
  }

  const { guest: updatedGuest, ...nonGuestUpdatedAttrs } = updateAttributes
  const { guest: existingGuest, ...nonGuestBriefAttrs } = briefState

  const newState = {
    ...nonGuestBriefAttrs,
    ...nonGuestUpdatedAttrs,
    guest: existingGuest || updatedGuest ? { ...existingGuest, ...updatedGuest } : undefined,
  }
  triggerSegmentationEventOnUserChange({ existingBrief: briefState, updatedBrief: newState })
  setStoredBrief(newState)
  return newState
}

export default briefReducer
